import { render, staticRenderFns } from "./MRMultiDropdown.vue?vue&type=template&id=f4b57d00"
import script from "./MRMultiDropdown.vue?vue&type=script&lang=ts"
export * from "./MRMultiDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports